export default "__VITE_ASSET__B4t47pr8__"